<template>
  <el-dialog
    :title="title"
    :visible="true"
    width="600px"
    :center="true"
    @close="close">
    <iframe title="协议" class="agreement" :src="url"></iframe>
  </el-dialog>
</template>

<script>
import { querySignContract } from '@/api/marketPromotion/activeData'
export default {
  data () {
    return {
      url: '',
      title: '灵活就业合作伙伴协议'
    }
  },
  created () {
    this.init()
  },
  methods: {
    init () {
      querySignContract({ business: 26 }).then(res => {
        if (res.code !== 200) return
        this.url = res.result.contractUrl
        this.title = res.result.title
      })
    },
    close () {
      this.$emit('close')
    }
  }
}
</script>

<style scoped>
.agreement{
  width: 100%;
  height: 500px;
}
</style>
